module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_null.0643b285.png";